const SysAPI = {
  CheckUserNameAPI: "/CommonAPI/Auth/CheckUserName",
  SignInAPI: "/CommonAPI/Auth/SignIn",
  VerifyOTPAPI: "/CommonAPI/Auth/VerifyOTP",
  EnvInfoAPI: "/CommonAPI/Env/Info",
  CheckInitAPI: "/CommonAPI/Env/IsInitialized",
  RenewAuthority: "/CommonAPI/Restore/RenewAuthority",
  ChangePassword: "/CommonAPI/Auth/ChangePassword",
  RefreshAuth: "/CommonAPI/Auth/Refresh",
  Blob: {
    Upload: "/CommonAPI/Blob/Upload",
    GetUrl: "/CommonAPI/Blob/GetUrl",
    GetBlob: "/CommonAPI/Blob/GetBlob",
    GetBlobNoAuth: "/CommonAPI/Blob/GetBlobNoAuth",
    Delete: "/CommonAPI/Blob/Delete"
  },
  SysUserRequest: {
    DBInfo: "/CommonAPI/User/Info",
    List: "/CommonAPI/User/List",
    Add: "/CommonAPI/User/Add",
    Delete: "/CommonAPI/User/Delete",
    Edit: "/CommonAPI/User/Edit",
    Export: "/CommonAPI/User/Export",
    Import: "/CommonAPI/User/Import",
    DeleteBulk: "/CommonAPI/User/DeleteBulk",
  },
  ACLibs: "/CommonAPI/ACLibs/Get"
};

export default SysAPI;